import { cn } from "@/utils/cn";

export default function SectionHeader({ title, className }) {
    return (
        <h2 className={cn(
            "text-xl font-semibold text-gray-800",
            className
        )}>
            {title}
        </h2>
    );
}